'use client';
import Link from 'next/link';
import React from 'react';

type MenuItem = {
  text: string;
  href: string;
};

type HeaderMenuProps = {
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>, href: string) => void;
};

const menuItems: MenuItem[] = [
  { text: 'Home', href: '/' },
  { text: 'Events', href: '/#events' },
  { text: 'Speakers', href: '/#speakers' },
  { text: 'Event Highlights', href: '/#event-highlights' },
  { text: 'Partners', href: '/#partners' },
  { text: 'About', href: '/#about' },
];

const HeaderMenu: React.FC<HeaderMenuProps> = ({ onLinkClick }) => {
  return (
    <nav className="flex flex-col lg:flex-row gap-4 lg:gap-[58px] items-start lg:items-center">
      {menuItems.map((item, index) => (
        <Link
          key={index}
          href={item.href}
          onClick={(e) => onLinkClick?.(e, item.href)}
          className="text-md font-medium leading-md font-HelveticaNeue capitalize transition-colors duration-200 hover:text-text-accent text-text-dark"
        >
          {item.text}
        </Link>
      ))}
    </nav>
  );
};

export default HeaderMenu;
